import { PureComponent } from 'preact-compat'

import { ContentType } from '@insided/shared/utils/contentType'
import { unvote, vote } from '../services/topicService'

export interface VoteProps {
  topicId: number
  contentType: ContentType
  votedBy: string[]
  votes: number
  onChangeVote: (votes: number, votedBy: string[]) => void
  userId?: string
}

class Vote extends PureComponent<VoteProps> {
  constructor (props: VoteProps) {
    super(props)
    this.voteTopic = this.voteTopic.bind(this)
    this.unvoteTopic = this.unvoteTopic.bind(this)
  }

  async voteTopic () {
    const { contentType, topicId, votedBy, userId, onChangeVote } = this.props
    await vote(contentType, topicId, Number(userId))
    const newVotedBy = [...votedBy]
    newVotedBy.push(String(userId))
    onChangeVote(newVotedBy.length, newVotedBy)
  }

  async unvoteTopic () {
    const { contentType, topicId, votedBy, userId, onChangeVote } = this.props
    await unvote(contentType, topicId, Number(userId))
    const newVotedBy = [...votedBy].filter(item => item !== userId)
    onChangeVote(newVotedBy.length, newVotedBy)
  }

  render () {
    const { votes, votedBy, userId } = this.props
    const userHasVoted = votedBy?.includes(String(userId))
    return (
      <div className='post--options-list-container-item'>
        <a data-qa='vote-topic' className={userHasVoted ? 'active' : ''} onClick={userHasVoted ? this.unvoteTopic : this.voteTopic}>
          <i className='fa fa-thumbs-up' /> Vote ({votes})
        </a>
      </div>
    )
  }
}

export default Vote
